import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import { monogramProduct } from "../../global/storefront/queries";

const cache = {};

export default function fetchProduct(id) {
  if (id in cache) {
    return cache[id];
  }

  cache[id] = storefront
    .request({
      query: monogramProduct,
      variables: {
        id,
        configId: window.theme.monogram_global_config,
      },
    })
    .then(({ data }) => {
      const output = unwrapNodes(data);

      return output;
    });

  return cache[id];
}
